require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require('../../../modules/es.array.iterator');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').keys;